/**
 * Kód pro overlay:
 * <div data-overlay-dialog="identifikator-dialogu" style="display: none">
 *     <a data-overlay-dialog-yes href="#">Ano</a>
 *     <a data-overlay-dialog-no href="#">Ne</a>
 *     <a data-overlay-dialog-close href="#">Zavřít</a>
 * </div>
 *
 * Kód pro otevírání:
 * <a href="..." data-overlay-dialog-target="identifikator-dialogu">Otevři overlay</a>
 */

let activeLink = null;

export function initialize() {
    document.querySelectorAll('[data-overlay-dialog]').forEach(function(element) {
        let yesLink = element.querySelector('[data-overlay-dialog-yes]');
        let noLink = element.querySelector('[data-overlay-dialog-no]');
        let closeLink = element.querySelector('[data-overlay-dialog-close]');

        yesLink.addEventListener('click', function() {
            if(activeLink !== null) {
                activeLink.click();
            }
        });

        noLink.addEventListener('click', function(e) {
            e.preventDefault();
            element.style.display = "none";
            activeLink = null;
        });

        closeLink.addEventListener('click', function(e) {
            e.preventDefault();
            element.style.display = "none";
            activeLink = null;
        });
    });

    document.querySelectorAll('a[data-overlay-dialog-target]').forEach(function(element) {
        let overlayId = element.getAttribute('data-overlay-dialog-target');
        let overlayTarget = document.querySelector('[data-overlay-dialog="'+overlayId+'"]');

        let listener = function(e) {
            if(activeLink !== element) {
                e.preventDefault();
                overlayTarget.style.display = "block";
                activeLink = element;
            }
        };

        element.addEventListener('click', listener);
    });
}
